module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/live-black-469c982b821b7124bbe7766b509cefb5.gif";